import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { actionCreators } from 'store/modules/staticFilters'
import { localized } from 'decorators'
import { LoadingIndicator } from 'components/loading'
import { Icon } from 'components/icons'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { TabItem } from './tabItem'

const FilterTabs = (props) => {
  const { get, page, setActiveTab } = props
  useEffect(() => { get(page) }, [get, page])
  const handleTabChange = React.useCallback((_, newTab) => { setActiveTab(newTab) }, [setActiveTab])

  const { fetching, entity, activeTab } = props.staticFilters
  if (fetching && entity.length === 0) { return <LoadingIndicator />}
  return (
    <React.Fragment>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        indicatorColor='secondary'
        textColor='primary'
        variant='scrollable'
        scrollButtons='auto'>
        {(entity || []).map((x, idx) => <Tab key={idx} label={x.title} />)}
        <Tab label={<span><Icon name='plus' />&nbsp;&nbsp;{props.localize('common.add')}</span>} title={props.localize('filters.addFiltersTooltip')} />
      </Tabs>
      <TabItem tabs={entity} index={activeTab} page={props.page} localize={props.localize} availableColumns={props.availableColumns} />
    </React.Fragment>
  )
}

export default connect(
  ({ staticFilters }) => ({ staticFilters }),
  {
    get: actionCreators.get,
    setActiveTab: actionCreators.setActiveTab
  })(localized(FilterTabs))